// Libs:
import React, { useEffect } from "react";
// css:
import "../assets/styles/pages/style.css";
// Header
import DepartmentHeader from "../components/DepartmentHeader";
// Layout
import LayoutOne from "../layouts/bodyLayouts/LayoutOne";
import BodyContent from "./bodyLayouts/BodyContent";
import currentPageStore from "../utils/stores/currentPageStore";
import Navbar from "../layouts/Navbar";
import Breadcrumbs from "../components/buttons/Breadcrumbs";
import ScrollToTop from "../components/ScrollToTop";
import Footer from "./Footer";

// Most department/division pages will follow this format.
function MasterPage({ pageID, bodyContent, pageHeader }) {
  console.log(window.location.pathname);

  const setCurrentPage = currentPageStore((state) => state.setCurrentPage);

  useEffect(() => {
    setCurrentPage(pageHeader);
    // console.log(pageHeader)
  }, [pageHeader]);
  return (
    <>
      <header role="banner">
        <Navbar iD={pageID} />
      </header>
      <main className="lead central-nav-container wrapper">
        <article className="main">
          <Breadcrumbs />
          <DepartmentHeader header={pageHeader} />
          <div className="bodyText">
            <BodyContent content={bodyContent} />
          </div>
        </article>
        <aside className="aside aside-2">
          <LayoutOne pageID={pageID} />
        </aside>
      </main>
      <ScrollToTop />
      <Footer />
    </>
  );
}
export default MasterPage;
